import { SxProp } from '@primer/react';
import { ElementType, AnchorHTMLAttributes, ReactNode } from 'react';
import { TextSize } from '../text/types';

export type LinkIndicator = 'underline' | 'color' | 'icon' | 'buttonLike' | 'override';

export enum FontWeight {
  LIGHT = '300',
  NORMAL = '400',
  SEMIBOLD = '500',
  BOLD = '600',
}

// "to" indicates an internal link that will use React Router. "href" indicates an external link that will use Primer's Link.
type ConditionalURLProps = { to: string } | { href: string };

type ConditionalIconProps =
  | { leadingIcon?: ElementType; trailingIcon?: never }
  | { leadingIcon?: never; trailingIcon?: ElementType };
/* Notes:
 * If we want to use any of the extra props that either library provides, we can do some more conditional propping.
   For now, the AnchorHTMLAttributes provide the native anchor element attributes (like "rel").
 * The SxProp only works for external links, since for internal we use React Router.
 */
export type LinkPlatformProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
  SxProp &
  ConditionalURLProps &
  ConditionalIconProps & {
    indicator: LinkIndicator;
    fontSize?: TextSize;
    fontWeight?: FontWeight;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    sizeIfButtonLike?: 'small' | 'medium' | 'large';
    to?: string;
    href?: string;
    children: ReactNode;
    style?: React.CSSProperties;
    isDisabled?: boolean;
  };
